import React from 'react';

export const HideUniversalHeader = (
    <style
        data-testid="hide-universal-header"
        dangerouslySetInnerHTML={{
            __html: `[data-testid="universal-header"] { display: none; }`
        }}
    />
);
